<template>
	<div class="center_invoice_list_container">
		<div style="display: flex; align-items: flex-end;">
			<div style="font-size: 17px; margin-right: 15px;">已开发票</div>
		</div>

		<el-alert type="warning" show-icon :closable="false" style="margin-top: 10px;">
			我社统一开具电子普票，会后发送至您预留的邮箱。如需专票，请联系工作人员。
		</el-alert>
		<div style="display: flex;flex-direction: column; margin-top: 5px;">
			<div style="display: flex; padding:30px 0px; line-height: 1; border-bottom: 1px solid #eee;"
				:class="{'border-no':index == productData.list.length-1}" v-for="(item,index) of productData.list">
				<div style="font-size: 16px;color: #333; font-weight: 600; margin-right: 30px;">¥{{item.total_fee}}
				</div>
				<div style="flex: 1; display: flex;  flex-direction: column;">
					<div style="font-size: 16px;color: #333; font-weight: 600;">{{item.title}}</div>
					<div style="font-size: 13px;color: #666; margin-top: 12px; display: flex;">
						<div v-if="item.updated_at">开票日期：{{item.updated_at}}</div>
						<div v-if="!item.updated_at">提交日期：{{item.created_at}}</div>
						<div v-if="item.state ==0" style="margin-left: 30px;">状态：开具中</div>
						<div v-if="item.state==1" style="margin-left: 30px;">状态：已开具</div>
						<div style="margin-left: 30px;" v-if="item.invoice_type == 2">形式：数电普票 </div>
						<div style="margin-left: 30px;" v-if="item.invoice_type == 1">形式：数电专票 </div>
						<div style="margin-left: 30px;">交付：{{item.email}}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="empty_box" v-if="productData.list && productData.list.length==0">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts" @click="toList()">
				<span class="empty_text">暂无已开发票</span>
			</div>
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";


	export default {
		data() {
			return {
				search: {
					page_index: 1,
					page_size: 10,
					order_by: 'created_at:desc'
				},
				productData: {
					total: 0,
					count: 0,
					list: null,
				},
				loading: false
			};
		},
		created() {
			document.title = "机工教师特训营";
			this.getProductList();
		},
		methods: {
			getProductList() {
				var that = this;
				var url = apiUrl.tt_invoice_list_get;
				this.Ajax(url, this.search, (data, code, msg) => {
					if (code == 0) {
						if (data) {
							if (that.productData.total == 0) {
								that.productData.total = data.total;
							}
							if (that.productData.count == 0) {
								that.productData.count = data.count;
							}
							if (that.search.page_index == 1) {
								that.productData.list = [];
							}
							that.productData.list = that.productData.list.concat(data.list);
						}
					} else if (code == 40004) {
						this.loading = false;
						if (that.search.page_index == 1) {
							that.productData.list = [];
						}
					}
				});
			},
			currentPage(index) {
				this.search.page_index = parseInt(index);
				this.getProductList();
			},
			nextPage() {
				if (this.search.page_index >= this.productData.count && this.search.page_index != 0) {
					this.search.page_index = this.productData.count;
					return;
				}
				this.loading = true;
				this.currentPage(this.search.page_index + 1);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.center_invoice_list_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;

		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.empty_icon {
				width: 220px;
				height: auto;
			}

			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;

				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
				}

				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
				}
			}
		}

		.border-no {
			border-bottom: none !important;
		}

	}
</style>